import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[auiHeaderContent]',
})
export class HeaderContentDirective {
}
